import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ArrowDown from 'dibs-vg/dist/react/arrow-down';
import ArrowUp from 'dibs-vg/dist/react/arrow-up';

import styles from './BuySharedFrequentlyAskedQuestionItem.scss';

export const BuySharedFrequentlyAskedQuestionItem = ({
    index,
    question,
    answer,
    onClick,
    isExpanded,
}) => {
    const questionWrapperClassNames = classNames(styles.questionWrapper, {
        [styles.questionWrapperExpanded]: isExpanded,
    });
    const Icon = isExpanded ? ArrowUp : ArrowDown;

    return (
        <div className={styles.wrapper}>
            <div
                className={questionWrapperClassNames}
                onClick={() => onClick(isExpanded ? -1 : index)}
            >
                <span className={styles.question} dangerouslySetInnerHTML={{ __html: question }} />
                <Icon className={styles.icon} />
            </div>
            {isExpanded && (
                <div className={styles.answer} dangerouslySetInnerHTML={{ __html: answer }} />
            )}
        </div>
    );
};

BuySharedFrequentlyAskedQuestionItem.propTypes = {
    index: PropTypes.number.isRequired,
    question: PropTypes.string.isRequired,
    answer: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    isExpanded: PropTypes.bool.isRequired,
};
